<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-container fluid>
        <v-flex xs12 md12>
          <v-card>
            <v-card-title class="headline">Tags</v-card-title>
            <div v-if="tags.length > 0">
              <div align="center">
                <v-chip
                  v-for="item in tags"
                  :key="item.id"
                  :color="colorRandom()"
                  avatar
                  class="ma-2"
                  text-color="white"
                >
                  <v-avatar left>
                    <v-icon>local_play</v-icon>
                  </v-avatar>
                  {{ item.name }}
                  <v-btn icon right>
                    <v-icon @click="editTag(item)" small color="white">
                      edit
                    </v-icon>
                  </v-btn>
                  <v-btn icon right>
                    <v-icon @click="deleteTag(item)" color="white" small>
                      delete
                    </v-icon>
                  </v-btn>
                </v-chip>
              </div>
            </div>

            <div v-else align="center">
              <v-nodata
                :loading="loading.tagOption"
                :networkError="networkError.tagOption"
                @retryMethod="getTags"
                title=""
                msg-details="You haven't added any tags yet"
                icon="clip-virtual-reality"
                content-bg="lighten-4"
              >
              </v-nodata>
            </div>

            <v-dialog v-model="tagDialog" max-width="500">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small absolute bottom right fab>
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="primary">
                  <h3 class="reg__heading" style="margin:0px">{{ formTitleTag }}</h3>
                </v-card-title>

                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 class="reg__custom__flex" style="margin-top: 10px">
                      <v-text-field
                        ref="tagName"
                        v-model="editedItem.name"
                        :rules="tagNameRules"
                        label="Tag Name"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 style="margin-top : 10px">
                      <h2
                        style="font-size: 13px; font-weight: 500; color:#1a1a1a; margin-left: 10px"
                      >
                        Assigned Members
                      </h2>
                    </v-flex>

                    <v-flex v-if="loader" xs12 sm12 md12 class="reg__custom__flex">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-flex>

                    <v-flex
                      v-else-if="assignes.length > 0 && formTitleTag == 'Edit'"
                      xs12
                      sm12
                      md12
                      class="reg__custom__flex"
                      style="text-align: left !important"
                    >
                      <v-chip
                        v-for="(user, index) in assignes"
                        :key="index"
                        class="ma-2"
                        color="primary"
                        text-color="white"
                        label
                      >
                        <v-avatar left color="#fafafa" style="color: #1a1a1a">
                          {{ user.firstName.substring(0, 1) }}
                        </v-avatar>
                        {{ user.email }}
                      </v-chip>
                    </v-flex>

                    <v-flex
                      v-else-if="
                        formTitleTag == 'New' || (assignes.length < 1 && formTitleTag == 'Edit')
                      "
                      xs12
                      sm12
                      md12
                      class="reg__custom__flex"
                      style="text-align: left !important"
                    >
                      <v-alert border="left" colored-border elevation="2" dense color="orange">
                        <h4
                          style="font-size: 12px; letter-spacing: 0.5px; font-weight: 500; color: #1a1a1a"
                        >
                          Currently you dont have any members assigned to this tag, please
                          <a href="/#/members">visit</a> the member's page to assign.
                        </h4>
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn @click.native="closeTag" color="primary" text>Cancel</v-btn>

                  <v-btn
                    v-if="formTitleTag == 'New'"
                    :loading="isChecked"
                    :disabled="isChecked"
                    @click.native="addTag"
                    color="primary"
                    >Save</v-btn
                  >

                  <v-btn
                    v-if="formTitleTag == 'Edit'"
                    :loading="isChecked"
                    :disabled="isChecked"
                    @click.native="addTag"
                    color="primary"
                    >Update</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
      </v-container>
    </v-layout>

    <v-layout row wrap>
      <div></div>
    </v-layout>

    <v-layout row wrap>
      <v-container fluid>
        <v-flex xs12 md12>
          <v-card>
            <v-card-title class="headline">Groups</v-card-title>
            <div v-if="groups.length > 0">
              <div align="center">
                <v-chip
                  v-for="item in groups"
                  :key="item.id"
                  :color="colorRandom()"
                  avatar
                  class="ma-2"
                  text-color="white"
                >
                  <v-avatar left>
                    <v-icon>group_work</v-icon>
                  </v-avatar>
                  {{ item.name }}
                  <v-btn icon right>
                    <v-icon @click="editGroup(item)" small color="white">
                      edit
                    </v-icon>
                  </v-btn>
                  <v-btn icon right>
                    <v-icon @click="deleteGroup(item)" color="white" small>
                      delete
                    </v-icon>
                  </v-btn>
                </v-chip>
              </div>
            </div>

            <div v-else align="center">
              <v-nodata
                :loading="loading.groupOption"
                :networkError="networkError.groupOption"
                @retryMethod="getGroups"
                title=""
                msg-details="You haven't added any groups yet"
                icon="page-under-construction-5"
              >
              </v-nodata>
            </div>

            <v-dialog v-model="groupDialog" max-width="500">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small absolute bottom right fab>
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="primary">
                  <span class="reg__heading" style="margin: 0px">{{ formTitleGroup }}</span>
                </v-card-title>

                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 class="reg__custom__flex" style="margin-top: 10px">
                      <v-text-field
                        ref="groupNameRules"
                        v-model="editedItem.name"
                        :rules="groupNameRules"
                        label="Group Name"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 style="margin-top : 10px">
                      <h2
                        style="font-size: 13px; font-weight: 500; color:#1a1a1a; margin-left: 10px"
                      >
                        Assigned Members
                      </h2>
                    </v-flex>

                    <v-flex v-if="loader" xs12 sm12 md12 class="reg__custom__flex">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-flex>

                    <v-flex
                      v-else-if="assignes.length > 0 && formTitleGroup == 'Edit'"
                      xs12
                      sm12
                      md12
                      class="reg__custom__flex"
                      style="text-align: left !important"
                    >
                      <v-chip
                        v-for="(user, index) in assignes"
                        :key="index"
                        class="ma-2"
                        color="primary"
                        text-color="white"
                        label
                      >
                        <v-avatar left color="#fafafa" style="color: #1a1a1a">
                          {{ user.firstName.substring(0, 1) }}
                        </v-avatar>
                        {{ user.email }}
                      </v-chip>
                    </v-flex>

                    <v-flex
                      v-else-if="
                        formTitleGroup == 'New' || (assignes.length < 1 && formTitleGroup == 'Edit')
                      "
                      xs12
                      sm12
                      md12
                      class="reg__custom__flex"
                      style="text-align: left !important"
                    >
                      <v-alert border="left" colored-border elevation="2" dense color="orange">
                        <h4
                          style="font-size: 12px; letter-spacing: 0.5px; font-weight: 500; color: #1a1a1a"
                        >
                          Currently you dont have any members assigned to this group, please
                          <a href="/#/members">visit</a> the member's page to assign.
                        </h4>
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn @click.native="closeGroup" color="blue darken-1" text>Cancel</v-btn>

                  <v-btn
                    v-if="formTitleGroup == 'New'"
                    :loading="isChecked"
                    :disabled="isChecked"
                    @click.native="addGroup"
                    color="primary"
                    >Save</v-btn
                  >

                  <v-btn
                    v-if="formTitleGroup == 'Edit'"
                    :loading="isChecked"
                    :disabled="isChecked"
                    @click.native="addGroup"
                    color="primary"
                    >Update</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
      </v-container>
    </v-layout>
    <!-- loader -->
    <v-dialog v-model="loaderDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- overlay -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import VNodata from "@/components/Unavailable/nodata.vue";
import canSee from "@/utilities/canSee";

export default {
  components: { VNodata },
  data() {
    return {
      loader: false,
      overlay: false,
      loaderDialog: false,
      isChecked: false,
      tagNameRules: [
        v => !!v || "Tag name is required",
        v => /^[A-Za-z0-9\-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Please enter a valid TagName"
      ],
      groupNameRules: [
        v => !!v || "Enter a GroupName",
        v => /^[A-Za-z0-9\-][a-zA-Z0-9 ]+[a-zA-Z0-9]*$/.test(v) || "Please enter a valid GroupName"
      ],
      loading: {
        tagOption: true,
        groupOption: true
      },
      networkError: {
        tagOption: false,
        groupOption: false
      },
      tagDialog: false,
      groupDialog: false,
      tags: [],
      groups: [],
      editedIndexTag: -1,
      editedIndexGroup: -1,
      setLoading: true,
      editedItem: {
        name: "",
        groupName: ""
      },
      defaultItem: {
        name: "",
        groupName: ""
      },
      updateTagId: "",
      assignes: []
    };
  },
  computed: {
    formTitleTag() {
      return this.editedIndexTag === -1 ? "New" : "Edit";
    },
    formTitleGroup() {
      return this.editedIndexGroup === -1 ? "New" : "Edit";
    }
  },
  watch: {
    tagDialog(val) {
      val || this.closeTag();
    },
    groupDialog(val) {
      val || this.closeTag();
    }
  },
  created() {
    this.getTags();
    this.getGroups();
  },
  methods: {
    colorRandom() {
      var colors = [
        "secondary",
        "primary",
        "orange",
        "success",
        "indigo",
        "blue-grey",
        "pink",
        "teal",
        "purple",
        "deep-orange"
      ];

      var mycolor = colors[Math.floor(Math.random() * colors.length)];

      // console.log("mycolor",mycolor)

      //  var mycolor = '#'+(Math.random()*0xFFFFFF<<0).toString(16)
      return mycolor;
    },

    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },

    getTags() {
      //  this.setLoading = true

      this.loading.tagOption = true;

      this.$http
        .get(
          `${this.$store.state.endpoint}tags?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.loading.tagOption = false;

            // console.log(response.body)
            this.tags = [];
            this.tags = response.body;
            // this.setLoading = false
            this.loaderDialog = false;
            this.isChecked = false;
          },
          error => {
            console.log(error);
            this.loading.tagOption = false;
            this.loaderDialog = false;
            this.isChecked = false;
            this.networkError.tagOption = true;
            // error callback
          }
        );
    },

    getGroups() {
      const self = this;

      this.loading.groupOption = true;

      // this.setLoading = true
      this.$http.get(`${this.$store.state.endpoint}groups/get`).then(
        response => {
          this.loading.groupOption = false;

          self.$store.dispatch("getGroups");

          // console.log(response.body)
          this.groups = [];
          this.groups = response.body;
          this.loaderDialog = false;
          this.isChecked = false;
          //  this.setLoading = false
        },
        error => {
          // console.log(error);
          this.loaderDialog = false;
          this.isChecked = false;
          this.loading.groupOption = false;
          this.networkError.groupOption = true;
        }
      );
    },

    closeTag() {
      // this.$refs.tagName.resetValidation()
      this.tagDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndexTag = -1;
      }, 300);
      this.loaderDialog = false;
      this.isChecked = false;
    },

    closeGroup() {
      //this.$refs.groupNameRules.resetValidation()

      this.groupDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndexGroup = -1;
      }, 300);
      this.loaderDialog = false;
      this.isChecked = false;
    },

    // edit tags and groups
    editTag(item) {
      this.editedIndexTag = this.tags.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.updateTagId = item.id;
      this.tagDialog = true;
      this.getTagsAssignes(item.id); //function call
    },

    editGroup(item) {
      this.editedIndexGroup = this.groups.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.updateTagId = item.id;
      this.groupDialog = true;
      this.getGroupsAssignes(item.id);
    },

    // get all the assignes
    getTagsAssignes(id) {
      this.assignes = [];
      this.loader = true;

      this.$http
        .get(
          `${this.$store.state.endpoint}accounts?filter[where][companyId]=${this.$store.getters.userDetails.companyId}&filter[where][tags]=${id}`
        )
        .then(response => {
          // console.log("All the assigned members", response.body)
          this.assignes = response.body;
          this.loader = false;
        })
        .catch(e => {
          // console.log("Error", e)
          this.loader = false;
        });
    },

    getGroupsAssignes(id) {
      this.assignes = [];
      this.loader = true;

      this.$http
        .get(
          `${this.$store.state.endpoint}accounts?filter[where][companyId]=${this.$store.getters.userDetails.companyId}&filter[where][groupId]=${id}`
        )
        .then(response => {
          // console.log("All the assigned members", response.body)
          this.assignes = response.body;
          this.loader = false;
        })
        .catch(e => {
          // console.log("Error", e)
          this.loader = false;
        });
    },

    // delete tags and groups
    deleteTag(item) {
      const self = this;
      this.$swal({
        text: `Are you sure you want to delete ${item.name}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          const itemObj = item.id;
          this.loaderDialog = true;
          // write item delete code
          this.$http.delete(`${this.$store.state.endpoint}tags/${itemObj}`).then(
            response => {
              // console.log(response.body);
              this.getTags();
              self.loaderDialog = false;
            },
            error => {
              console.log(error);
              self.loaderDialog = false;
              // error callback
            }
          );
        }
      });
    },
    deleteGroup(item) {
      const self = this;

      self
        .$swal({
          text: `Are you sure you want to delete ${item.name}?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes"
        })
        .then(result => {
          if (result.value) {
            const itemObj = item.id;
            self.loaderDialog = true;
            // write item delete code
            self.$http.delete(`${self.$store.state.endpoint}groups/${itemObj}`).then(
              response => {
                self.getGroups();
                self.loaderDialog = false;
              },
              error => {
                self.$swal({ type: "error", text: error.body.error.message });
                self.loaderDialog = false;
              }
            );
          }
        });
    },

    // add tags and groups
    addTag() {
      this.loaderDialog = true;
      this.isChecked = true;

      if (this.editedIndexTag > -1) {
        if (this.editedItem.name == "") {
          this.loaderDialog = false;
          this.isChecked = false;
          this.$swal({
            type: "warning",
            title: "Please Enter Tag Name"
          });
          return;
        }

        if (this.$refs.tagName.validate() == false) {
          // console.log('false');
          this.loaderDialog = false;
          this.isChecked = false;
          this.$swal({
            type: "warning",
            text: "Please enter a valid TagName"
          });
        } else {
          // console.log('true');
          const updateObj = {
            name: this.editedItem.name
          };

          this.$http.patch(`${this.$store.state.endpoint}tags/${this.updateTagId}`, updateObj).then(
            response => {
              // success callback
              // console.log(response.body);
              this.$refs.tagName.resetValidation();
              this.getTags();
            },
            error => {
              // console.log(error);
              // error callback
              this.loaderDialog = false;
              this.isChecked = false;
              this.$swal({ type: "error", title: "Oops", text: "Something went wrong." });
            }
          );
          this.closeTag();
        }
      } else if (this.$refs.tagName.validate() == false) {
        // console.log('false');
        this.loaderDialog = false;
        this.isChecked = false;
        this.$swal({
          type: "warning",
          text: "Please enter a valid TagName"
        });
      } else {
        const postObj = {
          name: this.editedItem.name,
          companyId: this.$store.state.userDetails.companyId
        };
        // validation for tag Name
        for (const x in this.tags) {
          if (postObj.name.toLowerCase() == this.tags[x].name.toLowerCase()) {
            this.loaderDialog = false;
            this.isChecked = false;
            this.$swal({ type: "warning", text: "Enter a different tag name" });
            return;
          }
        }

        this.$http.post(`${this.$store.state.endpoint}tags`, postObj).then(
          response => {
            this.$refs.tagName.resetValidation();
            this.getTags();
          },
          error => {
            this.loaderDialog = false;
            this.isChecked = false;
            this.$swal({ type: "error", title: "Oops", text: "Something went wrong." });
          }
        );

        this.closeTag();
      }
    },

    addGroup() {
      this.loaderDialog = true;
      this.isChecked = true;

      if (this.$refs.groupNameRules.validate() == false) {
        // console.log('false');
        this.loaderDialog = false;
        this.isChecked = false;
        this.$swal({
          type: "warning",
          text: "Please Enter GroupName"
        });
      } else {
        // console.log('true');
        const self = this;
        if (this.editedIndexGroup > -1) {
          const updateObj = {
            name: this.editedItem.name
          };
          this.$http
            .patch(`${this.$store.state.endpoint}groups/${this.updateTagId}`, updateObj)
            .then(
              response => {
                self.getGroups();
                self.$refs.groupNameRules.resetValidation();
              },
              error => {
                // console.log(error);
                this.loaderDialog = false;
                this.isChecked = false;
              }
            );
          this.$swal({
            type: "success",
            text: "Successfully updated"
          });
          this.closeGroup();
        } else if (this.$refs.groupNameRules.validate() == false) {
          // console.log('false');
          this.loaderDialog = false;
          this.isChecked = false;
          this.$swal({
            type: "warning",
            text: "Group name invalid"
          });
        } else {
          // console.log('true');
          const postObj = {
            name: this.editedItem.name,
            companyId: this.$store.state.userDetails.companyId
          };
          // validation for group Name
          for (const x in self.groups) {
            if (postObj.name.toLowerCase() == self.groups[x].name.toLowerCase()) {
              this.loaderDialog = false;
              this.isChecked = false;
              self.$swal({ type: "warning", text: "Enter a different group name" });
              return;
            }
          }
          this.$http.post(`${this.$store.state.endpoint}groups`, postObj).then(
            response => {
              self.getGroups();
              self.$refs.groupNameRules.resetValidation();
            },
            error => {
              // console.log(error);
              this.loaderDialog = false;
              this.isChecked = false;
            }
          );
          this.closeGroup();
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
